import { mapSerializer as mapSerializer$1, fixSerializer as fixSerializer$1, reverseSerializer as reverseSerializer$1, mergeBytes as mergeBytes$1, padBytes as padBytes$1, fixBytes as fixBytes$1, utf8 as utf8$1, baseX as baseX$1, base10 as base10$1, base58 as base58$1, base64 as base64$1, base16 as base16$1, bitArray as bitArray$1, removeNullCharacters as removeNullCharacters$1, padNullCharacters as padNullCharacters$1, Endian as Endian$1 } from '@metaplex-foundation/umi-serializers';

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const mapSerializer = mapSerializer$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const fixSerializer = fixSerializer$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const reverseSerializer = reverseSerializer$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const mergeBytes = mergeBytes$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const padBytes = padBytes$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const fixBytes = fixBytes$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const utf8 = utf8$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const baseX = baseX$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base10 = base10$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base58 = base58$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base64 = base64$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base16 = base16$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const bitArray = bitArray$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const removeNullCharacters = removeNullCharacters$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const padNullCharacters = padNullCharacters$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const Endian = Endian$1;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

export { Endian, base10, base16, base58, base64, baseX, bitArray, fixBytes, fixSerializer, mapSerializer, mergeBytes, padBytes, padNullCharacters, removeNullCharacters, reverseSerializer, utf8 };
//# sourceMappingURL=serializersInternal.mjs.map
